export type PhotoCategory = 'portrait' | 'stage' | 'studio'
export type FilterKey = 'all' | PhotoCategory

export type Photo = {
  id: string
  src: string
  category: PhotoCategory
  span?: boolean
}

export type Reel = {
  id: string
  poster: string
}

export type Snippet = {
  id: string
  poster: string
}

export const filterKeys: FilterKey[] = ['all', 'portrait', 'stage', 'studio']

export const photos: Photo[] = [
  {
    id: 'headshot',
    src: 'https://cdn.magicpatterns.com/uploads/fywdmyYFGhrwgCMm4W1mBz/Fauve_1.jpg',
    category: 'portrait',
  },
  {
    id: 'portrait-soft',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/5261cb73-1fa8-4398-a40b-39a0349d7bb2.jpg',
    category: 'portrait',
  },
  {
    id: 'stage1',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/8f555737-72d6-491a-b142-df3a03e60271.jpg',
    category: 'stage',
    span: true,
  },
  {
    id: 'dance-studio',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/a29a2c20-d665-4709-ac43-3183471bb268.jpg',
    category: 'studio',
  },
  {
    id: 'ballet',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/36200591-dd9e-4870-af14-934f42052735.jpg',
    category: 'studio',
  },
  {
    id: 'teaching',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/b2cb3dcf-e962-4040-99a6-d5076a67aba0.jpg',
    category: 'studio',
    span: true,
  },
  {
    id: 'stage2',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/6eb1e28a-fb8e-4110-b65b-8b8747691aa0.jpg',
    category: 'stage',
    span: true,
  },
]

export const reels: Reel[] = [
  {
    id: 'reel-dance',
    poster:
      'https://cdn.magicpatterns.com/patterns/generated-images/2fc7ba2f-0c54-4cc5-bf94-73dbb2f3db89.jpg',
  },
  {
    id: 'reel-voice',
    poster:
      'https://cdn.magicpatterns.com/patterns/generated-images/43df044e-0233-4a39-83e9-4f3cbb6bf388.jpg',
  },
  {
    id: 'reel-acting',
    poster:
      'https://cdn.magicpatterns.com/patterns/generated-images/7f43981e-0f6c-4e64-bba6-cce54d20beae.jpg',
  },
]

export const snippets: Snippet[] = [
  {
    id: 'snippet-stage',
    poster:
      'https://cdn.magicpatterns.com/patterns/generated-images/8f555737-72d6-491a-b142-df3a03e60271.jpg',
  },
  {
    id: 'snippet-arena',
    poster:
      'https://cdn.magicpatterns.com/patterns/generated-images/6eb1e28a-fb8e-4110-b65b-8b8747691aa0.jpg',
  },
  {
    id: 'snippet-teaching',
    poster:
      'https://cdn.magicpatterns.com/patterns/generated-images/b2cb3dcf-e962-4040-99a6-d5076a67aba0.jpg',
  },
]
